var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 224,
    viewBox: "0 0 318 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.929 80.6105C80.888 80.0655 79.9513 79.5477 79.8692 79.3569L0 88.1249L143.069 220.182C143.527 220.693 144.149 221.095 144.757 221.477L141.66 212.634L80.929 80.6105Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.787 125.39C136.758 134.499 137.728 143.614 138.713 152.723L148.333 135.098L135.787 125.39Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.304 102.091L151.444 86.1287L133.407 73.4844C132.354 73.6002 131.294 73.716 130.234 73.8318C131.274 83.247 132.292 92.6689 133.298 102.091H133.304Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.713 152.723C137.728 143.614 136.757 134.499 135.787 125.39L120.375 113.468L133.304 102.091C132.293 92.6686 131.281 83.2467 130.241 73.8315C115.089 75.487 97.5647 78.5596 82.6247 79.0909C81.5512 79.1318 81.558 78.9411 80.8401 78.7367C80.4777 78.6345 80.129 78.4437 79.7666 78.3416C79.8555 78.6549 79.7666 79.0909 79.876 79.3566C79.9512 79.5474 80.8948 80.0652 80.9358 80.6102L141.66 212.633L127.725 172.868L138.72 152.723H138.713Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.407 73.4844L129.927 71.0454L130.234 73.8318C131.287 73.716 132.347 73.6002 133.407 73.4844Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.472 20.5427C131.506 16.278 127.513 12.0405 123.459 7.87793L122.953 7.93243L125.77 33.3847L135.479 20.5427H135.472Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7598 78.3416L57.7772 14.5747L0 88.1246L79.8692 79.3566C79.7598 79.0909 79.8419 78.6549 79.7598 78.3416Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8335 78.737L122.953 7.93266L123.459 7.87816L123.404 7.37402C101.531 9.76528 79.6438 12.1838 57.7773 14.575L79.76 78.3419C80.1224 78.4441 80.4711 78.6348 80.8335 78.737Z",
    fill: "#C6C6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.472 20.5427L147.417 4.73047C139.41 5.60931 131.404 6.48814 123.404 7.36698L123.459 7.87112C127.513 12.0337 131.506 16.2712 135.472 20.5359V20.5427Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.235 73.8319L129.927 71.0455L108.608 56.0984L125.763 33.3917L122.946 7.93945L80.8267 78.7438C81.5446 78.9482 81.5378 79.1321 82.6113 79.0981C97.5513 78.5667 115.083 75.4873 130.228 73.8387L130.235 73.8319Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.152 222.403C146.316 222.532 146.166 224.903 147.677 222.232L147.171 222.287L146.152 222.396V222.403Z",
    fill: "#CF1F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.653 212.634L144.751 221.477C145.25 221.79 145.749 222.083 146.146 222.403L141.653 212.634Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.714 212.388C173.605 212.634 173.701 213.09 173.619 213.403L174.131 213.451C174.542 212.988 174.617 211.993 176.128 211.625L317.904 77.6945L317.952 77.1835L237.461 69.4307C217.167 117.487 194.548 164.577 173.714 212.381V212.388Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.73 92.9143C183.95 100.688 183.164 108.454 182.378 116.227L192.668 128.286L179.629 143.58C177.441 165.565 175.321 187.556 173.468 209.548C173.393 210.406 172.921 211.775 173.715 212.382C194.549 164.577 217.167 117.488 237.461 69.4309C221.885 67.9321 206.289 66.4333 190.713 64.9277L205.769 80.9853L184.737 92.9143H184.73Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.714 212.388C172.921 211.782 173.393 210.413 173.468 209.554C175.328 187.563 177.441 165.571 179.629 143.587L164.73 161.061L170.207 202.823L172.6 213.301L173.619 213.397C173.708 213.083 173.612 212.627 173.714 212.382V212.388Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 101.416L182.377 116.227C183.164 108.454 183.95 100.681 184.73 92.9141L169.742 101.416Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.533 66.1132C224.312 48.9997 214.186 31.1028 203.601 13.5397L191.465 24.1334L187.807 61.8417L190.713 64.9346C206.288 66.4403 221.892 67.939 237.461 69.4378L317.952 77.1907L318 76.6797C297.959 52.9716 278.958 28.3777 259.19 4.41064L237.755 68.9541C236.811 68.8451 236.045 66.8967 235.533 66.1064V66.1132Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.533 66.1131C236.053 66.9034 236.811 68.8518 237.755 68.9608L259.191 4.4173C245.646 3.10926 232.094 1.80804 218.542 0.5L203.602 13.5395C214.186 31.1026 224.312 48.9996 235.533 66.1131Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.807 61.8416L191.465 24.1333L170.009 42.8614L187.807 61.8416Z",
    fill: "#F0EFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318,
    height: 223,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenGem);
export default __webpack_public_path__ + "static/media/BrokenGem.ba0e07687a295ac0e733e30cad3239d2.svg";
export { ForwardRef as ReactComponent };